// @ts-ignore
// eslint-disable-next-line
import MapDistanceWorker from 'comlink-loader!./distance.worker';

export default MapDistanceWorker;
